const initialState = {
  total_pages: 1,
  current_page: 1,
  documents: []
}

export default (state = initialState, action) => {
  switch (action.type) {
    case "UPDATE_DOCUMENTS_CREATE":
      const new_document = action.payload.document

      return { ...state, documents: [new_document, ...state.documents] }
    case "UPDATE_DOCUMENTS":
      return action.payload.documents;
    case "DELETE_DOCUMENT":
      let documents = state.documents.filter((doc) => {
        return doc.id !== action.payload.document.id
      })

      return { ...state, documents }
    case "UPDATE_CURRENT_PAGE":
      return {
        ...state,
        current_page: action.payload.currentPage
      }
    default:
      return state;
  }
}
